import { render, staticRenderFns } from "./TotalAcessosAnoDash.vue?vue&type=template&id=715e98b1&"
import script from "./TotalAcessosAnoDash.vue?vue&type=script&lang=js&"
export * from "./TotalAcessosAnoDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports